import { createElementBlock as l, openBlock as o, createElementVNode as t } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function r(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    t("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M17.575 4.25a2.75 2.75 0 1 1 0 5.5 2.75 2.75 0 0 1 0-5.5M22.825 7a5.25 5.25 0 1 0-10.5 0 5.25 5.25 0 0 0 10.5 0M7.46 20.884 6.575 20c.884.884.884.884.883.885l-.003.003-.004.004-.01.01a3 3 0 0 1-.114.104 3.855 3.855 0 0 1-1.293.742 3.1 3.1 0 0 1-1.602.11c-.62-.123-1.21-.445-1.74-.974a1.25 1.25 0 0 1 1.767-1.768c.22.22.38.274.463.291q.137.03.32-.03a1.4 1.4 0 0 0 .43-.245l.533-.64a5.7 5.7 0 0 1-1.051-.846 1.25 1.25 0 1 1 1.768-1.767c.337.337.589.494.746.566.082.038.14.053.177.06l3.282-3.82a1.25 1.25 0 1 1 1.896 1.63l-2.926 3.406-.061.08-2.5 3q-.037.042-.077.083",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const d = { render: r };
export {
  d as default,
  r as render
};
//# sourceMappingURL=ic_key_alt-oTHoKffu.js.map
